import script from "./ChatDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatDialog.vue?vue&type=script&setup=true&lang=js"

import "./ChatDialog.vue?vue&type=style&index=0&id=141db688&lang=less&scoped=true"

import exportComponent from "F:\\work\\projects\\HiOmics\\Front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-141db688"]])

export default __exports__